<template>
  <v-overlay v-model="centerLoading" :scrim="false" class="custom_centered_overlay">
    <v-progress-circular color="green" indeterminate size="64"></v-progress-circular>
  </v-overlay>

  <v-app id="app_lead_list">
    <v-container fluid>
      <v-row class="pl-2 pr-6">
        <v-col class="mt-3" cols="7">
          <p class="custom_page_main_title">TOTAL NEW VISITS</p>
          <p class="custom_page_main_sub_title" style="opacity: 0.6">Analyse new visits data in a variety of parameters.</p>
        </v-col>
        <v-col class="px-4 mt-5" cols="5">
          <v-row class="custom_tool_bar_style">
            <v-btn color="#800080" size="x-large" variant="text" style="border-radius: 2px !important;" @click="createLead()">
              <v-icon>mdi-plus-circle</v-icon>&nbsp;&nbsp;CREATE NEW VISIT
            </v-btn>
            <v-divider :thickness="3" class="divider-vertical" vertical></v-divider>
            <v-btn class="gray-text" size="x-large" variant="text" style="border-radius: 2px !important;" @click="backPageRoute()">
              <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-card class="custom_card_box mt-8" elevation="1" border="sm opacity-1" rounded="lg" style="border-radius: 2px !important;">
        <v-card-text class="custom_tool_bar_style">
          <v-btn class=" custom_pdf_btn" variant="outlined" style="border-radius: 2px !important;" @click="exportPDF">
            <v-icon size="large">mdi-file-pdf</v-icon>&nbsp;&nbsp;PDF
          </v-btn>
          <v-btn class="custom_excel_btn ml-4" variant="outlined" style="border-radius: 2px !important;" @click="exportExcel">
            <v-icon size="large">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
          </v-btn>
        </v-card-text>

        <v-divider thickness="2"></v-divider>

        <v-card-text>
          <v-row class="mt-0">
            <v-col cols="12" md="6">
              <v-text-field
                v-model="mainSearch"
                append-inner-icon="mdi-magnify"
                label="Search New Visits"
                placeholder="Search in all fields"
                variant="outlined"
                density="comfortable"
                hide-details
                clearable
                class="custom_input_field_color"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-date-input v-model="assignDate" @click:append-inner="clearAssignDate" append-inner-icon="mdi-close"
                            label="Assign Date" prepend-inner-icon="$calendar" multiple="range"
                            prepend-icon="" placeholder="Select Date Range" variant="outlined" density="comfortable"
                            hide-details
                            class="custom_input_field_color"

              ></v-date-input>
            </v-col>

            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="filters.visitedStatus"
                :items="visitStatus"
                label="Visited Status"
                placeholder="Select Status"
                variant="outlined"
                density="comfortable"
                class="custom_input_field_color"
                hide-details
                multiple
                clearable
                @update:model-value="applyFilters"
              >
                <template v-slot:chip="{ props, item }">
                  <v-chip
                    v-bind="props"
                    color="#e7e7e7"
                    variant="flat"
                    class="text-black font-weight-medium"
                    size="small"
                    closable
                  >
                    {{ item.title }}
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="filters.area_code"
                :items="allAreaCodesList"
                item-title="formattedDisplay"
                item-value="area_code"
                label="Area"
                placeholder="Select area"
                variant="outlined"
                density="comfortable"
                class="custom_input_field_color"
                hide-details
                multiple
                clearable
                @update:model-value="applyFilters"
              >
                <template v-slot:chip="{ props, item }">
                  <v-chip
                    v-bind="props"
                    color="#e7e7e7"
                    variant="flat"
                    class="text-black font-weight-medium"
                    size="small"
                    closable
                  >
                    {{ item.raw.formattedDisplay }}
                  </v-chip>
                </template>

                <template v-slot:item="{ props, item }">
                  <v-list-item v-bind="props" :title="item.raw.formattedDisplay">
                    <template v-slot:prepend>
                      <v-checkbox-btn :model-value="filters.area_code.includes(item.raw.area_code)"></v-checkbox-btn>
                    </template>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="filters.approvalStatus"
                :items="approvalStatusList"
                label="Approval Status"
                placeholder="Select Status"
                variant="outlined"
                density="comfortable"
                class="custom_input_field_color"
                hide-details
                multiple
                clearable
                @update:model-value="applyFilters"
              >
                <template v-slot:chip="{ props, item }">
                  <v-chip
                    v-bind="props"
                    color="#e7e7e7"
                    variant="flat"
                    class="text-black font-weight-medium"
                    size="small"
                    closable
                  >
                    {{ item.title }}
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-divider class="mt-4"></v-divider>

          <v-data-table v-model:page="page" v-model:items-per-page="itemsPerPage" :headers="headers" :items="filteredItems" 
                        :loading="loading" class="custom_table_normal mt-2" item-key="id" item-value="id">
            
            <template v-slot:[`item.visited_status`]="{ item }">
              <v-chip v-if="['Visited', 'Completed'].includes(formatVisitedStatus(item.visited_status, item.assign_date))" class="custom_green_chip" size="small" variant="outlined">
                <span class="text-black font-weight-bold" style="color: black !important;">{{ formatVisitedStatus(item.visited_status, item.assign_date) }}</span>
                <v-icon class="justify-end ml-2" style="color: black !important;">mdi-check</v-icon>
              </v-chip>

              <v-chip v-else-if="formatVisitedStatus(item.visited_status, item.assign_date) === 'Pending'" class="custom_orange_chip" size="small" variant="outlined">
                <span class="text-black font-weight-bold" style="color: black !important;">{{ formatVisitedStatus(item.visited_status, item.assign_date) }}</span>
                <v-icon class="justify-end ml-2" style="color: black !important;">mdi-clock-outline</v-icon>
              </v-chip>

              <v-chip v-else class="custom_red_chip" size="small" variant="outlined">
                <span class="text-black font-weight-bold" style="color: black !important;">{{ formatVisitedStatus(item.visited_status, item.assign_date) }}</span>
                <v-icon class="justify-end ml-2" style="color: black !important;">mdi-close</v-icon>
              </v-chip>
            </template>

            <template v-slot:[`item.approval_status`]="{ item }">
              <div class="d-flex flex-column align-start gap-1">
                <v-chip v-if="formatApprovalStatus(item.approval_status) === 'Approved'" class="custom_green_chip mb-1" size="small" variant="outlined">
                  <span class="text-black font-weight-bold" style="color: black !important;">{{ formatApprovalStatus(item.approval_status) }}</span>
                  <v-icon class="justify-end ml-2" style="color: black !important;">mdi-check-circle</v-icon>
                </v-chip>

                <v-chip v-else-if="formatApprovalStatus(item.approval_status) === 'New Visit'" class="custom_orange_chip mb-1" size="small" variant="outlined">
                  <span class="text-black font-weight-bold" style="color: black !important;">{{ formatApprovalStatus(item.approval_status) }}</span>
                  <v-icon class="justify-end ml-2" style="color: black !important;">mdi-clock-outline</v-icon>
                </v-chip>

                <v-chip v-else-if="formatApprovalStatus(item.approval_status) === 'Reject' || formatApprovalStatus(item.approval_status) === 'Reject'" class="custom_red_chip mb-1" size="small" variant="outlined">
                  <span class="text-black font-weight-bold" style="color: black !important;">{{ formatApprovalStatus(item.approval_status) }}</span>
                  <v-icon class="justify-end ml-2" style="color: black !important;">mdi-close-circle</v-icon>
                </v-chip>

                <v-chip v-else class="custom_red_chip mb-1" size="small" variant="outlined">
                  <span class="text-black font-weight-bold" style="color: black !important;">{{ formatApprovalStatus(item.approval_status) }}</span>
                </v-chip>
              </div>
            </template>

            <template v-slot:[`item.create_username`]="{ item }">
              <div class="d-flex flex-column align-start gap-1">
                <span class="text-body-2">{{ item.create_username || 'N/A' }}</span>
                <v-chip v-if="isCreatedByMeUser(item.create_userId)" color="#800080" size="small" variant="flat" style="margin-top: 4px; border-radius: 2px !important;">
                  <span class="text-white font-weight-bold">Created by me</span>
                </v-chip>
              </div>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-menu transition="slide-x-transition" id="app_product_list">
                <template v-slot:activator="{ props }">
                  <v-btn style="background-color: #800080; color: white; border-radius: 2px !important;" variant="flat" size="large" v-bind="props">
                    ACTIONS &nbsp; &nbsp;<v-icon>mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                  <v-list>
                    <v-list-item v-if="permissions.read" @click="viewItem(item)">
                      <v-list-item-title class="custom_font_color_view">VIEW</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                      v-if="permissions.write && !['Visited', 'Completed'].includes(formatVisitedStatus(item.visited_status, item.assign_date))"
                      @click="editItem(item)">
                      <v-list-item-title class="custom_font_color_edit">EDIT</v-list-item-title>
                    </v-list-item>

                    <v-list-item 
                      v-if="permissions.delete && (!item.lead_status || item.lead_status.toUpperCase() !== 'IN PROGRESS')" 
                      @click="confirmDelete(item)">
                      <v-list-item-title class="custom_font_color_delete">DELETE</v-list-item-title>
                    </v-list-item>
                  </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <v-dialog v-model="view_leads_dialog" fullscreen id="app_lead_list">
        <v-card flat>
          <v-toolbar style="border-radius: 0px !important;"
                     class="custom_fullscreen_dialog_toolbar pr-5 custom_card_box" color="white" dense>
            <v-toolbar-title>
              <v-img class="custom_company_logo_nav" :src="require('@/img/company_logo/logo-dark 2.png')"
                     @click="homeReload()"></v-img>
            </v-toolbar-title>
            <v-spacer></v-spacer>
              <v-btn 
                variant="flat" 
                style="background-color: #800080 !important; color: #ffffff !important; border-radius: 2px !important;" 
                @click="cancelAndRefresh"
              >
                CLOSE
              </v-btn>
          </v-toolbar>

          <v-row class="mt-15  custom_scroll_option_fullscreen_dialog" v-if="selectedLead">
            <v-col cols="12" md="12">
              <v-card class="pa-0 mx-6 mt-2 custom_card_box" border="sm opacity-1" style="border-radius: 2px !important;">
                <template v-slot:prepend>
                  <v-icon>mdi-view-dashboard</v-icon>
                  <v-card-title class="font-weight-bold custom_page_main_sub_title ml-3">NEW VISIT DETAILS</v-card-title>
                </template>
              </v-card>

              <v-card class="pa-3 mx-6 custom_card_box mt-4" border="sm opacity-1" style="border-radius: 2px !important;">
                <v-row class="ma-0">
                  <v-col cols="12" xs="12" sm="4" md="9" lg="9">
                    <v-row>
                      <v-col cols="12" xs="12" sm="12" md="3" lg="2" xl="2">
                        <v-img
                            :src="UserResponseData.user_image ? `${imageURL}/${UserResponseData.user_image}` : require('@/assets/ASSETS/PERSONS/person-3.jpg')"
                            aspect-ratio="1" class="user_image_view"></v-img>
                      </v-col>
                      <v-col cols="12" xs="12" sm="12" md="9" lg="10" xl="10">
                        <div class="d-flex">
                          <p class="font-weight-bold custom_page_component_main_title text-body-1">User Name:
                            &nbsp;</p>
                          <p class="font-weight-bold custom_page_component_main_title"
                             style="color: #05146F !important;">{{ selectedLead.salesRep_name || selectedLead.agent_name }}</p>
                        </div>

                        <div class="d-flex mt-1">
                          <p class="font-weight-bold custom_page_component_main_title text-body-1">Mobile: &nbsp;</p>
                          <p class="font-weight-medium text-body-2 custom_page_component_main_title mt-1">
                            {{ selectedLead.mobile_number }}</p>
                        </div>

                        <div class="d-flex mt-6">
                          <v-chip v-if="['Visited', 'Completed'].includes(formatVisitedStatus(selectedLead.visited_status, selectedLead.assign_date))" class="custom_green_chip" variant="outlined">
                            <v-icon style="color: black !important;">mdi-check-circle-outline</v-icon>&nbsp;
                            <span class="text-black font-weight-bold" style="color: black !important;">{{ formatVisitedStatus(selectedLead.visited_status, selectedLead.assign_date) }}</span>
                          </v-chip>

                          <v-chip v-else-if="formatVisitedStatus(selectedLead.visited_status, selectedLead.assign_date) === 'Pending'" class="custom_orange_chip" variant="outlined">
                            <v-icon style="color: black !important;">mdi-clock-outline</v-icon>&nbsp;
                            <span class="text-black font-weight-bold" style="color: black !important;">{{ formatVisitedStatus(selectedLead.visited_status, selectedLead.assign_date) }}</span>
                          </v-chip>

                          <v-chip v-else class="custom_red_chip" variant="outlined">
                            <v-icon style="color: black !important;">mdi-close</v-icon>&nbsp;
                            <span class="text-black font-weight-bold" style="color: black !important;">{{ formatVisitedStatus(selectedLead.visited_status, selectedLead.assign_date) }}</span>
                          </v-chip>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xs="12" sm="3" md="3" lg="3">
                    <v-row class="text-right mt-3 mr-3">
                      <v-spacer></v-spacer>
                      
                      <v-btn
                          v-if="permissions.delete && (!selectedLead.lead_status || selectedLead.lead_status.toUpperCase() !== 'IN PROGRESS')" class="custom_delete_btn" icon rounded="0"
                          size="small" variant="outlined" style="border-radius: 2px !important;" @click="confirmDelete(selectedLead)"
                      >
                        <v-icon>mdi-trash-can</v-icon>
                        <v-tooltip activator="parent" location="top">Delete</v-tooltip>
                      </v-btn>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <v-divider></v-divider>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" xs="12" sm="6" md="3" lg="3">
                    <v-text-field
                        v-model="selectedLead.lead_title"
                        class="px-3 custom_input_field_class_view  custom_input_field_color"
                        label="New Visit Title" placeholder="Type title here" readonly variant="outlined"
                        density="comfortable"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" xs="12" sm="6" md="3" lg="3">
                    <v-text-field
                        v-model="selectedLead.area_code" density="comfortable"
                        class="px-3 custom_input_field_class_view  custom_input_field_color" label="Area Code"
                        readonly variant="outlined"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" xs="12" sm="6" md="3" lg="3">
                    <v-text-field
                        v-model="selectedLead.salesRep_name" label="Assign Sales Rep" readonly density="comfortable"
                        variant="outlined" class="mt-2 px-3 custom_input_field_class_view  custom_input_field_color"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" xs="12" sm="6" md="3" lg="3">
                    <v-text-field
                        v-model="selectedLead.assign_date" density="comfortable"
                        label="Assign Date" readonly
                        class="mt-2 px-3 custom_input_field_class_view  custom_input_field_color" variant="outlined"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="12" lg="12" v-if="selectedLead.approval_status && ['REJECT', 'REJECTED'].includes(selectedLead.approval_status.toUpperCase().trim())">
                    <v-text-field
                      v-model="selectedLead.approval_reason" density="comfortable"
                      class="px-3 custom_input_field_class_view custom_input_field_color" label="Reject Reason" readonly variant="outlined"
                      base-color="error" color="error"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <div class="px-3 mb-4">
                      <p class="custom_page_main_sub_title">New Visit Description</p>
                      <v-divider class="mt-3 mb-4"></v-divider>
                      <v-card color="#F7F7F7" flat border="sm opacity-1" outlined density="comfortable" style="border-radius: 2px !important;">
                        <v-card-text>
                          <div v-html="getSanitizedHTML(selectedLead.discription || selectedLead.lead_description || '')"
                               class=" ml-3 ql-container ql-snow"></div>
                        </v-card-text>
                      </v-card>
                    </div>

                  </v-col>
                </v-row>

                <v-row class="px-3">
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <v-divider class="mt-1 mb-3"></v-divider>
                    <p class="custom_page_main_sub_title">
                      <strong>SELECTED NEW VISITS LIST</strong>
                    </p>
                    <p class="custom_page_main_sub_title mt-2" style="opacity: 0.6">
                      The following table shows all the institutes related to the above-defined new visit.
                    </p>

                    <v-card class="mt-4 mb-4 custom_card_box" elevation="1" border="sm opacity-1" rounded="lg" style="border-radius: 2px !important;">
                      <v-card-text>
                        <v-data-table :headers="headers_two" :items="selectedLead.selected_lead"
                                      density="default"
                                      :items-per-page="-1"
                                      class="custom_table_normal">
                          <template v-slot:bottom>
                            <div class="d-none"></div>
                          </template>
                          <template v-slot:[`item.visited_status`]="{ item }">
                            <v-chip v-if="['Visited', 'Completed'].includes(formatVisitedStatus(item.visited_status, selectedLead.assign_date))" class="custom_green_chip" size="small"
                                    variant="outlined">
                              <v-icon style="color: black !important;">mdi-check-circle-outline</v-icon>&nbsp; 
                              <span class="text-black font-weight-bold" style="color: black !important;">{{ formatVisitedStatus(item.visited_status, selectedLead.assign_date) }}</span>
                            </v-chip>

                            <v-chip v-else-if="formatVisitedStatus(item.visited_status, selectedLead.assign_date) === 'Pending'" class="custom_orange_chip" size="small"
                                    variant="outlined">
                              <v-icon style="color: black !important;">mdi-clock-outline</v-icon>&nbsp; 
                              <span class="text-black font-weight-bold" style="color: black !important;">{{ formatVisitedStatus(item.visited_status, selectedLead.assign_date) }}</span>
                            </v-chip>

                            <v-chip v-else class="custom_red_chip" size="small"
                                    variant="outlined">
                              <v-icon style="color: black !important;">mdi-close</v-icon>&nbsp; 
                              <span class="text-black font-weight-bold" style="color: black !important;">{{ formatVisitedStatus(item.visited_status, selectedLead.assign_date) }}</span>
                            </v-chip>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>

      <v-dialog v-model="edit_leads_dialog" fullscreen id="app_lead_list">
        <v-card flat>
          <v-toolbar style="border-radius: 0px !important;"
                     class="custom_fullscreen_dialog_toolbar pr-5 custom_card_box" color="white" dense>
            <v-toolbar-title>
              <v-img class="custom_company_logo_nav" :src="require('@/img/company_logo/logo-dark 2.png')"
                     @click="homeReload()"></v-img>
            </v-toolbar-title>
            <v-spacer></v-spacer>
              <v-btn 
                variant="flat" 
                style="background-color: #800080 !important; color: #ffffff !important; border-radius: 2px !important;" 
                @click="cancelAndRefresh"
              >
                CLOSE
              </v-btn>
          </v-toolbar>

          <v-row class="mt-15  custom_scroll_option_fullscreen_dialog" v-if="selectedLead">
            <v-col cols="12" md="12">
              <v-card class="pa-0 mx-6 mt-2 custom_card_box" border="sm opacity-1" style="border-radius: 2px !important;">
                <template v-slot:prepend>
                  <v-icon>mdi-view-dashboard</v-icon>
                  <v-card-title class="font-weight-bold custom_page_main_sub_title ml-3">UPDATE NEW VISIT DETAILS
                  </v-card-title>
                </template>
              </v-card>

              <v-card class="pa-3 mx-6 custom_card_box mt-4" border="sm opacity-1" style="border-radius: 2px !important;">
                <v-row class="ma-0">
                  <v-col cols="12" xs="12" sm="4" md="9" lg="9">
                    <v-row>
                      <v-col cols="12" xs="12" sm="12" md="3" lg="2" xl="2">
                        <v-img
                            :src="UserResponseData.user_image ? `${imageURL}/${UserResponseData.user_image}` : require('@/assets/ASSETS/PERSONS/person-3.jpg')"
                            aspect-ratio="1" class="user_image_view"></v-img>
                      </v-col>
                      <v-col cols="12" xs="12" sm="12" md="9" lg="10" xl="10">
                        <div class="d-flex">
                          <p class="font-weight-bold custom_page_component_main_title text-body-1">User Name:
                            &nbsp;</p>
                          <p class="font-weight-bold custom_page_component_main_title"
                             style="color: #05146F !important;">{{ selectedLead.agent_name }}</p>
                        </div>

                        <div class="d-flex mt-1">
                          <p class="font-weight-bold custom_page_component_main_title text-body-1">Mobile: &nbsp;</p>
                          <p class="font-weight-medium text-body-2 custom_page_component_main_title mt-1">
                            {{ selectedLead.mobile_number }}</p>
                        </div>

                        <div class="d-flex mt-6">
                          <v-chip v-if="['Visited', 'Completed'].includes(formatVisitedStatus(selectedLead.visited_status, selectedLead.assign_date))" class="custom_green_chip"
                                  variant="outlined">
                            <v-icon style="color: black !important;">mdi-check-circle-outline</v-icon>&nbsp;
                            <span class="text-black font-weight-bold" style="color: black !important;">{{ formatVisitedStatus(selectedLead.visited_status, selectedLead.assign_date) }}</span>
                          </v-chip>

                          <v-chip v-else-if="formatVisitedStatus(selectedLead.visited_status, selectedLead.assign_date) === 'Pending'" class="custom_orange_chip"
                                  variant="outlined">
                            <v-icon style="color: black !important;">mdi-clock-outline</v-icon>&nbsp;
                            <span class="text-black font-weight-bold" style="color: black !important;">{{ formatVisitedStatus(selectedLead.visited_status, selectedLead.assign_date) }}</span>
                          </v-chip>

                          <v-chip v-else class="custom_red_chip"
                                  variant="outlined">
                            <v-icon style="color: black !important;">mdi-close</v-icon>&nbsp;
                            <span class="text-black font-weight-bold" style="color: black !important;">{{ formatVisitedStatus(selectedLead.visited_status, selectedLead.assign_date) }}</span>
                          </v-chip>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xs="12" sm="3" md="3" lg="3">
                    <v-row class="text-right mt-3 mr-3">
                      <v-spacer></v-spacer>
                        <v-btn 
                          variant="flat" 
                          size="large" 
                          style="background-color: #800080 !important; color: #ffffff !important; border-radius: 2px !important;" 
                          @click="updateLead()"
                        >
                          UPDATE NEW VISIT
                        </v-btn>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <v-divider></v-divider>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                    <v-text-field
                        v-model="selectedLead.lead_title" :disabled="['Visited', 'Completed'].includes(formatVisitedStatus(selectedLead.visited_status, selectedLead.assign_date))"
                        class="px-3 custom_input_field_color"
                        label="New Visit Title *" placeholder="Type title here" variant="outlined" density="comfortable"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                    <v-autocomplete class="px-3 custom_input_field_color" density="comfortable"
                                    v-model="selectedLead.area_code"
                                    :items="areaCodesList"
                                    item-title="area_code" item-value="area_code" label="Area Code *"
                                    placeholder="Select Area Code" variant="outlined"
                                    @update:model-value="fetchSalesRepByAreaCode"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                    <v-autocomplete class="px-3 custom_input_field_color" density="comfortable"
                                    v-model="selectedLead.agent_name"
                                    :disabled="['Visited', 'Completed'].includes(formatVisitedStatus(selectedLead.visited_status, selectedLead.assign_date))" 
                                    :items="agents"
                                    item-title="name" item-value="name" label="Assign Sales Rep *"
                                    placeholder="Select agent" variant="outlined"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                    <v-date-input v-model="assignDateObject" :disabled="['Visited', 'Completed'].includes(formatVisitedStatus(selectedLead.visited_status, selectedLead.assign_date))"
                                  label="Assign Date *" persistent-placeholder
                                  variant="outlined" density="comfortable" class="px-3 custom_input_field_color"
                                  prepend-icon="" prepend-inner-icon="$calendar"
                                  color="#800080"
                    ></v-date-input>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="12" lg="12" v-if="selectedLead.approval_status && ['REJECT', 'REJECTED'].includes(selectedLead.approval_status.toUpperCase().trim())">
                    <v-text-field
                      v-model="selectedLead.approval_reason" density="comfortable"
                      class="px-3 custom_input_field_class_view custom_input_field_color" label="Reject Reason" readonly variant="outlined"
                      base-color="error" color="error"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <v-row class="px-3">
                      <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                        <p class="custom_page_main_sub_title" style="opacity: 0.6">Type New Visit Description </p>
                        <v-divider class="mt-4 mb-3"></v-divider>
                        <v-card class="mt-5" elevation="1" border="sm opacity-1" rounded="0" max-height="355"
                                min-height="355" style="border-radius: 2px !important;">
                          <Toolbar :editor="editorRef" :defaultConfig="toolbarConfig" :mode="mode"/>
                          <v-divider></v-divider>
                          <Editor v-model="selectedLead.discription" :defaultConfig="editorConfig" :mode="mode"
                                  @onCreated="handleCreated"/>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row class="px-3">
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <v-divider class="mt-1 mb-3"></v-divider>
                    <p class="custom_page_main_sub_title">
                      <strong>RELATED NEW VISITS LIST</strong>
                    </p>
                    <p class="custom_page_main_sub_title mt-2" style="opacity: 0.6">
                      The following table shows all the institutes related to the above-defined new visit. You can click on the map icon to change location details.
                    </p>

                    <v-card class="mt-4 mb-4 custom_card_box" elevation="1" border="sm opacity-1" rounded="lg" style="border-radius: 2px !important;">
                      <v-card-text>
                        <v-data-table :headers="headers_two" :items="selectedLead.selected_lead"
                                      density="default"
                                      :items-per-page="-1"
                                      class="custom_table_normal">
                          <template v-slot:bottom>
                            <div class="d-none"></div>
                          </template>
                          <template v-slot:[`item.sub_category`]="{ item }">
                            <p class="custom_page_main_sub_title_very_small_red text-caption font-weight-medium">
                              {{ item.sub_category || 'N/A' }}</p>
                          </template>
                          
                          <template v-slot:[`item.institute_name`]="{ item }">
                            <v-text-field v-model="item.institute_name" density="compact" variant="plain" hide-details class="my-1 custom_input_field_color"></v-text-field>
                          </template>
                          
                          <template v-slot:[`item.address`]="{ item, index }">
                            <v-text-field v-model="item.address" density="compact" variant="plain" hide-details append-inner-icon="mdi-map-marker" @click:append-inner="openMapPicker(item, index)" class="my-1 custom_input_field_color"></v-text-field>
                          </template>

                          <template v-slot:[`item.visited_status`]="{ item }">
                            <v-chip v-if="['Visited', 'Completed'].includes(formatVisitedStatus(item.visited_status, selectedLead.assign_date))" class="custom_green_chip" size="small"
                                    variant="outlined">
                              <v-icon style="color: black !important;">mdi-check-circle-outline</v-icon>&nbsp; 
                              <span class="text-black font-weight-bold" style="color: black !important;">{{ formatVisitedStatus(item.visited_status, selectedLead.assign_date) }}</span>
                            </v-chip>

                            <v-chip v-else-if="formatVisitedStatus(item.visited_status, selectedLead.assign_date) === 'Pending'" class="custom_orange_chip" size="small"
                                    variant="outlined">
                              <v-icon style="color: black !important;">mdi-clock-outline</v-icon>&nbsp; 
                              <span class="text-black font-weight-bold" style="color: black !important;">{{ formatVisitedStatus(item.visited_status, selectedLead.assign_date) }}</span>
                            </v-chip>

                            <v-chip v-else class="custom_red_chip" size="small"
                                    variant="outlined">
                              <v-icon style="color: black !important;">mdi-close</v-icon>&nbsp; 
                              <span class="text-black font-weight-bold" style="color: black !important;">{{ formatVisitedStatus(item.visited_status, selectedLead.assign_date) }}</span>
                            </v-chip>
                          </template>

                          <template v-slot:[`item.visited_date`]="{ item }">
                            <span v-if="['Visited', 'Completed'].includes(formatVisitedStatus(item.visited_status, selectedLead.assign_date)) && item.visited_date">{{ item.visited_date.split(' ')[0] }}</span>

                            <v-btn v-else class="custom_btn_primary" dark @click="openReminderDialog(item)" style="border-radius: 2px !important;">REMINDER
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showMapDialog" max-width="800" persistent>
        <v-card style="border-radius: 2px !important;">
          <v-toolbar style="background-color: #800080; color: #ffffff;" dark>
            <v-toolbar-title class="text-white">Select Location Details</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="showMapDialog = false" class="text-white"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-card-text class="pa-0 position-relative">
            <input ref="mapSearchInput" type="text" placeholder="Search a place" class="map-search-input" />
            <GMapMap
              ref="myMapRef"
              :center="mapCenter"
              :zoom="mapZoom"
              style="width: 100%; height: 500px"
              :options="{mapTypeControl: false, streetViewControl: false}"
            ></GMapMap>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="custom_btn_secondary mr-2" variant="outlined" @click="showMapDialog = false" style="border-radius: 2px !important;">CANCEL</v-btn>
            <v-btn class="custom_btn_primary" style="background-color: #800080 !important; color: white !important; border-radius: 2px !important;" @click="saveMapLocation">SELECT LOCATION</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="deleteLeadDialog" id="app_lead_list" max-height="500" max-width="500" persistent
                @update:model-value="resetDialogState">
        <v-card rounded="0" style="border-radius: 2px !important;">
          <div class="pa-4">
            <v-card color="#F0F0F0" flat>
              <template v-slot:prepend>
                <v-card-title class="text-subtitle-1 font-weight-bold">DELETE LEAD</v-card-title>
              </template>
              <v-spacer></v-spacer>
              <template v-slot:append>
                <v-btn @click="deleteLeadDialog = false; resetDialogState()" icon="mdi-close" size="x-small"></v-btn>
              </template>
            </v-card>

            <v-card color="white" flat class="mt-3">
              <v-card-item>
                <v-card-title style="color: #BB0000" class="text-body-1 font-weight-bold">
                  <v-icon color="warning" size="small">mdi-alert</v-icon>
                  &nbsp;&nbsp;Do you want to delete this New Visit??
                </v-card-title>

                <p style="opacity: 0.7;" class="text-body-2 mt-4 text-justify">
                  <span v-if="visited_count > 0">
              This new visit cannot be deleted because it has {{ visited_count }} associated data in the following tables. Please remove the associations first.
            </span>
                  <span v-else>
              This new visit will be deleted immediately. Once deleted, it can no longer be used for any purpose.
            </span>
                </p>

                <v-divider class="mt-4"></v-divider>

                <div v-if="visited_count > 0">
                  <div class="text-body-2 mt-4 text-justify"><strong>New Visit Count:</strong> {{ visited_count }}
                  </div>
                  <div class="text-body-2 text-justify"><strong>New Visit Agent:</strong> {{ agent_name }} / {{ reg_num }}
                  </div>
                  <div class="text-body-2 text-justify"><strong>New Visit Assign Date:</strong> {{ assign_date }}</div>
                  <div class="text-body-2 text-justify"><strong>New Visit ID:</strong> {{ LeadID }}</div>
                </div>

                <v-timeline align="start" density="compact">
                  <v-timeline-item
                      v-for="(lead) in salesLeadList"
                      :key="lead.id"
                      dot-color="#05146F"
                  >
                    <template v-slot:opposite></template>
                    <div>
                      <p><strong>New Visit ID:</strong> {{ lead.id }}</p>
                      <p><strong>New Visit Institute Name:</strong> {{ lead.institute_name }}</p>
                      <p><strong>New Visit Sub Category:</strong> {{ lead.sub_category || 'N/A' }}</p>
                      <p><strong>New Visit Date:</strong> {{ formatDate(lead.created_at) }}</p>
                    </div>
                  </v-timeline-item>
                </v-timeline>

                <v-divider class="mt-4"></v-divider>

                <div class="float-end mt-4 ">
                  <v-btn
                    color="red"
                    @click="deleteItem"
                    :disabled="salesLeadList.length > 0"
                    style="border-radius: 2px !important;"
                  >
                    DELETE
                  </v-btn>
                  <v-btn class="ml-3 custom_btn_secondary" @click="deleteLeadDialog = false; resetDialogState()" style="border-radius: 2px !important;">CANCEL</v-btn>
                </div>
              </v-card-item>
            </v-card>
          </div>
        </v-card>
      </v-dialog>

      <v-dialog v-model="reminderDialog" max-height="700" id="app_lead_list" max-width="600">
        <v-card rounded="0" style="overflow:hidden !important; border-radius: 2px !important;">
          <div class="pa-4">
            <v-card color="#F0F0F0" flat>
              <template v-slot:prepend>
                <v-card-title class="text-subtitle-1 font-weight-bold">SEND REMINDER</v-card-title>
              </template>
              <v-spacer></v-spacer>
              <template v-slot:append>
                <v-btn @click="reminderDialog = false" icon="mdi-close" size="x-small"></v-btn>
              </template>
            </v-card>

            <v-card flat class="mt-3">
              <div style="overflow-y: auto !important;height: 450px !important;margin-left: -1% !important;"
                   class="px-2">
                <v-tabs v-model="tab" align-tabs="left" next-icon="mdi-arrow-right-bold-box-outline"
                        prev-icon="mdi-arrow-left-bold-box-outline" show-arrows>
                  <v-tab class="custom_page_main_sub_title" value="one">REASON</v-tab>
                  <v-tab class="custom_page_main_sub_title" value="two">SEND REMINDER</v-tab>
                </v-tabs>

                <v-tabs-window v-model="tab">
                  <v-tabs-window-item class="mt-9" value="one">
                    <v-textarea
                        :value="selectedItem.not_visited_leads && selectedItem.not_visited_leads.length > 0 ? selectedItem.not_visited_leads[0].not_visited_reason : 'No data available'"
                        readonly
                        @input="handleInput"
                        density="comfortable"
                        name="input-7-4"
                        variant="outlined"
                        class="custom_input_field_color"
                    />
                  </v-tabs-window-item>

                  <v-tabs-window-item class="mt-9" value="two">
                    <v-text-field
                        v-model="selectedLead.lead_title"
                        :rules="[v => !!v || 'New Visit Title is required']"
                        density="comfortable"
                        readonly
                        label="New Visit Title"
                        placeholder="Type New Visit Title"
                        required
                        variant="outlined"
                        class="custom_input_field_color"
                    ></v-text-field>

                    <v-text-field
                        v-model="selectedItem.institute_name"
                        :rules="[v => !!v || 'Outlet Name is required']"
                        density="comfortable"
                        readonly
                        label="Outlet Name"
                        placeholder="Type Outlet Name"
                        required
                        variant="outlined"
                        class="mt-2 custom_input_field_color"
                    ></v-text-field>

                    <v-text-field
                        v-model="selectedItem.address"
                        :rules="[v => !!v || 'Outlet Address is required']"
                        density="comfortable"
                        readonly
                        label="Outlet Address"
                        placeholder="Type Outlet Address"
                        required
                        variant="outlined"
                        class="mt-2 custom_input_field_color"
                    ></v-text-field>

                    <v-text-field
                        v-model="selectedLead.agent_name"
                        :rules="[v => !!v || 'Assignee is required']"
                        density="comfortable"
                        readonly
                        label="Assignee"
                        placeholder="Type Assignee"
                        required
                        variant="outlined"
                        class="mt-2 custom_input_field_color"
                    ></v-text-field>

                    <v-text-field
                        v-model="selectedLead.mobile_number"
                        :rules="[v => !!v || 'Mobile number is required']"
                        density="comfortable"
                        readonly
                        label="Mobile"
                        placeholder="Type Mobile Number Here"
                        required
                        variant="outlined"
                        class="mt-2 custom_input_field_color"
                    ></v-text-field>

                    <v-text-field
                        v-model="UserResponseData.email"
                        :rules="[v => !!v || 'Email is required']"
                        density="comfortable"
                        readonly
                        label="Email"
                        placeholder="Type Email Here"
                        required
                        variant="outlined"
                        class="mt-2 custom_input_field_color"
                    ></v-text-field>

                    <v-textarea
                        v-model="selectedItem.note"
                        :rules="[v => !!v || 'Note is required']"
                        density="comfortable"
                        label="Note"
                        placeholder="Type Note Here"
                        required
                        rows="3"
                        variant="outlined"
                        class="mt-2 custom_input_field_color"
                    ></v-textarea>
                  </v-tabs-window-item>
                </v-tabs-window>
              </div>
              <v-divider class="mt-4"></v-divider>
              <div v-if="tab === 'two'" class="float-end mt-4">
                <v-btn class="custom_btn_primary" @click="sendReminder" style="border-radius: 2px !important;">SEND</v-btn>
                <v-btn class="ml-3 custom_btn_secondary" @click="reminderDialog = false" style="border-radius: 2px !important;">CANCEL</v-btn>
              </div>
            </v-card>
          </div>
        </v-card>
      </v-dialog>

      <v-dialog v-model="reminderDialogNew" max-height="700" id="app_lead_list" max-width="650">
        <v-card rounded="0" style="overflow:hidden !important; border-radius: 2px !important;">
          <div class="pa-4">
            <v-card color="#F0F0F0" flat>
              <template v-slot:prepend>
                <v-card-title class="text-subtitle-1 font-weight-bold">SEND A REMINDER TO THE AGENT
                  <br />
                   <span class="text-primary text-caption">NOT VISITED LEADS</span>
                </v-card-title>
              </template>
              <v-spacer></v-spacer>
              <template v-slot:append>
                <v-btn @click="reminderDialogNew = false" icon="mdi-close" size="x-small"></v-btn>
              </template>
            </v-card>

            <v-card flat class="mt-3">
              <div style="overflow-y: auto !important;height: 450px !important;margin-left: -1% !important;"
                   class="px-2">
                  
                <v-alert type="warning" density="compact" class="mt-3">
                  The first reminder has already been sent.
                  <strong>Date: 2024 - 01 - 14</strong>
                </v-alert>

                <v-row class="mt-4">
                  <v-col cols="6">
                    <v-text-field
                        v-model="selectedLead.lead_title"
                        density="comfortable"
                        readonly
                        label="New Visit Title"
                        placeholder="New Visit Title"
                        required
                        variant="outlined"
                        class="custom_input_field_color"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                        v-model="selectedLead.assignee"
                        density="comfortable"
                        readonly
                        label="Assignee"
                        placeholder="Assignee"
                        required
                        variant="outlined"
                        class="custom_input_field_color"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <h4 class="text-subtitle-1 font-weight-medium mt-4">LEADS LIST</h4>
                <p class="text-caption text-secondary">This table shows the institute selected for the reminder to be sent to.</p>
                <v-data-table 
                  :headers="headersNotVisitedTable" 
                  :items="notVisitedOutletItem"
                  :items-per-page="itemsPerPage" 
                  :search="search" 
                  density="default"
                  class="custom_table_normal"
                >
                  <template v-slot:headers="{ columns }">
                    <tr>
                      <th v-for="column in columns" :key="column.text" class="text-left">
                        <div v-if="column.value === 'select'" class="d-flex align-center">
                          <v-checkbox 
                            v-model="selectAllOutlet" 
                            @change="toggleSelectAllOutletItem"
                            density="compact"
                            hide-details
                            :color="selectAllOutlet ? 'blue-darken-2' : 'grey-darken-1'"
                          ></v-checkbox>
                          <span class="ml-8 font-weight-bold">ALL</span>
                        </div>
                        <span v-else-if="column.value === 'sub_category'" class="font-weight-bold">Outlet Name</span>
                        <span v-else-if="column.value === 'address'" class="font-weight-bold">Address</span>
                        <span v-else-if="column.value === 'visited_status'" class="font-weight-bold">Agent Visited Status</span>
                        <span v-else-if="column.value === 'crmStatus'" class="font-weight-bold">CRM Status</span>
                      </th>
                    </tr>
                  </template>

                  <template v-slot:[`item.select`]="{ item }">
                    <v-checkbox 
                      v-model="selectedItems" 
                      :value="item.id" 
                      density="compact"
                      hide-details
                      :color="selectedItems.includes(item.id) ? 'blue-darken-2' : 'grey-darken-1'"
                    ></v-checkbox>
                  </template>

                  <template v-slot:[`item.crmStatus`]="{ item }">
                    <v-chip class="custom_red_chip" size="small" variant="outlined">
                      <v-icon style="color: black !important;">mdi-close</v-icon>&nbsp; 
                      <span class="text-black font-weight-bold" style="color: black !important;">NOT COMPLETED {{ item.sa }}</span>
                    </v-chip>
                  </template>

                  <template v-slot:[`item.visited_status`]="{ item }">
                    <v-chip v-if="['Visited', 'Completed'].includes(formatVisitedStatus(item.visited_status, selectedLead.assign_date))" class="custom_green_chip" size="small"
                      variant="outlined">
                      <v-icon style="color: black !important;">mdi-check-circle-outline</v-icon>&nbsp; 
                      <span class="text-black font-weight-bold" style="color: black !important;">{{ formatVisitedStatus(item.visited_status, selectedLead.assign_date) }}</span>
                    </v-chip>
                    <v-chip v-else-if="formatVisitedStatus(item.visited_status, selectedLead.assign_date) === 'Pending'" class="custom_orange_chip" size="small"
                      variant="outlined">
                      <v-icon style="color: black !important;">mdi-clock-outline</v-icon>&nbsp; 
                      <span class="text-black font-weight-bold" style="color: black !important;">{{ formatVisitedStatus(item.visited_status, selectedLead.assign_date) }}</span>
                    </v-chip>
                    <v-chip v-else class="custom_red_chip" size="small"
                      variant="outlined">
                      <v-icon style="color: black !important;">mdi-close</v-icon>&nbsp; 
                      <span class="text-black font-weight-bold" style="color: black !important;">{{ formatVisitedStatus(item.visited_status, selectedLead.assign_date) }}</span>
                    </v-chip>
                  </template>

                </v-data-table>

                <v-row class="mt-4">
                  <v-col cols="6">
                    <v-text-field
                        v-model="selectedLead.mobile_number"
                        density="comfortable"
                        readonly
                        label="Mobile Number"
                        placeholder="Mobile Number"
                        required
                        variant="outlined"
                        class="custom_input_field_color"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                        v-model="selectedLead.agent_email"
                        density="comfortable"
                        readonly
                        label="Email"
                        placeholder="Email"
                        required
                        variant="outlined"
                        class="custom_input_field_color"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-textarea
                  v-model="reminderMessage"
                  label="Reminder Note"
                  density="comfortable"
                  name="input-7-4"
                  variant="outlined"
                  class="custom_input_field_color"
                  maxlength="250"
                  counter
                />
              </div>
              <v-divider class="mt-4"></v-divider>
              <v-card-actions class="d-flex justify-end pa-4">
                <v-btn class="custom_btn_primary" @click="sendReminderNew" style="border-radius: 2px !important;">SEND</v-btn>
              </v-card-actions>
            </v-card>
          </div>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="snackAlert.snackbar" :color="snackAlert.snackColor" :right="snackAlert.snackBarRight"
                  :top="snackAlert.snackBarTop" location="top right" timeout="3000">
        {{ snackAlert.snackMessage }}
      </v-snackbar>
    </v-container>
  </v-app>
</template>

<script>
import axios from 'axios';
import _ from 'lodash';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from "xlsx";
import {getPermissions} from "@/plugins/permissions";
import DOMPurify from 'dompurify';

import '@wangeditor/editor/dist/css/style.css';
import {i18nChangeLanguage} from '@wangeditor/editor'

i18nChangeLanguage('en')
import {Editor, Toolbar} from '@wangeditor/editor-for-vue'
import {onBeforeUnmount, ref, shallowRef, onMounted} from 'vue'

export default {
  components: {
    Editor,
    Toolbar,
  },

  setup() {
    const editorRef = shallowRef()
    const valueHtml = ref('<p></p>')

    onMounted(() => {
      setTimeout(() => {
        valueHtml.value = '<p></p>'
      }, 1500)
    })

    const toolbarConfig = {toolbarKeys: ['bold', 'italic', 'underline', 'through']}
    const editorConfig = {placeholder: 'Type here...'}

    onBeforeUnmount(() => {
      const editor = editorRef.value
      if (editor == null) return
      editor.destroy()
    })

    const handleCreated = (editor) => {
      editorRef.value = editor
    }

    return {
      editorRef,
      mode: 'simple',
      valueHtml,
      toolbarConfig,
      editorConfig,
      handleCreated
    };
  },

  name: 'LeadsList',
  data() {
    return {
      baseURL: process.env.VUE_APP_API_BASE_URL || "",
      salesLeadList: [],
      visited_count: 0,
      agent_name: '',
      reg_num: '',
      LeadID: '',
      assign_date: '',
      reminderMessage: '',
      UserResponseData: {
        email: '',
      },
      imageURL: "",
      centerLoading: false,
      dataDescription: '',
      formatting: [],
      showColorPicker: false,
      selectedColor: '#000',
      alignment: '',
      textareaStyles: {
        fontStyle: 'normal',
        fontWeight: 'normal',
        textDecoration: 'none',
        color: '#000',
        textAlign: 'left',
      },
      tab: null,
      smsMobile: '',
      smsEmail: '',
      smsNote: '',
      mainSearch: '',

      headers: [
        {title: 'NEW VISIT TITLE', value: 'lead_title', sortable: true},
        {title: 'INSTITUTE NAME', value: 'institute_name', sortable: true},
        {title: 'SALES REP NAME', value: 'salesRep_name', sortable: true},
        {title: 'ADDRESS', value: 'address', sortable: true},
        {title: 'AREA CODE', value: 'area_code', sortable: true},
        {title: 'VISITED STATUS', value: 'visited_status', sortable: true},
        {title: 'APPROVAL STATUS', value: 'approval_status', sortable: true},
        {title: 'ASSIGN DATE', value: 'assign_date', sortable: true},
        {title: 'CREATED BY', value: 'create_username', sortable: true},
        {title: 'ACTION', value: 'actions', sortable: false}
      ],
      items: [],
      totalItems: 5,
      page: 1,
      itemsPerPage: 10,
      filters: {
        startDate: '',
        endDate: '',
        visitedStatus: [],
        area_code: [], 
        date: [],
        approvalStatus: [],
      },
      visitStatus: ['COMPLETED', 'NOT COMPLETED', 'PENDING', 'VISITED', 'NOT VISITED'],
      approvalStatusList: ['Approved', 'New Visit', 'Reject'],
      view_leads_dialog: false,
      edit_leads_dialog: false,
      assignDateObject: new Date(),
      deleteLeadDialog: false,
      deleteLeadListEditDialog: false,
      reminderDialog: false,
      reminderDialogNew:false,
      selectedItem: {},
      smsDialog: false,
      assignDate: null,
      file: null,
      showLeadsCard: true,
      lead: {
        title: '',
        mainCategory: '',
        sub_category: '',
        province: '',
        district: '',
        description: '',
        dsd: '',
        gnd: '',
        assignAgent: '',
        assign_date: '',
      },
      headersTwoT: [
        {text: '', value: 'data-table-select', title: 'data-table-select'},
        {text: 'Sub Category', value: 'subCategory', sortable: true, title: 'Sub Category'},
        {text: 'Institute Name', value: 'instituteName', sortable: true, title: 'Institute Name'},
        {text: 'Address', value: 'address', sortable: true, title: 'Address'},
      ],

      headers_two: [
        {title: 'Institute Name', text: 'Institute Name', value: 'institute_name', sortable: true},
        {title: 'Address', text: 'Address', value: 'address', sortable: true},
        {title: 'Area', text: 'Area', value: 'area_code', sortable: true},
        {title: 'Assign Date', text: 'Assign Date', value: 'assign_date', sortable: true},
        {title: 'Status', text: 'Status', value: 'visited_status', sortable: true},
      ],

      headersNotVisitedTable:[
        {text: 'All', value: 'select',  align: 'center', sortable: true, title: 'All'},
        {text: 'Outlet Name', value: 'sub_category', sortable: true, title: 'Outlet Name'},
        {text: 'Address', value: 'address', sortable: true, title: 'Address'},
        {text: 'Agent Visited Status', value: 'visited_status', sortable: true, title: 'Agent Visited Status'},
        {text: 'CRM Status', value: 'crmStatus', sortable: true, title: 'CRM Status'},
      ],
      notVisitedOutletItem:[],
      selectedItems: [],
      selectAllOutlet: false,
      items_two: [],

      headers_dialog: [
        {text: 'Main Category', value: 'mainCategory', title: 'Main Category'},
        {text: 'Sub Category', value: 'sub_category', title: 'Sub Category'},
        {text: 'Assign Sales Rep', value: 'assignAgent', title: 'Assign Sales Rep'},
        {text: 'Assign Date', value: 'assign_date', title: 'Assign Date'},
        {text: 'Description', value: 'description', title: 'Description'},
        {text: 'New Visit List', value: 'leadList', title: 'New Visit List'},
      ],
      items_dialog: [],
      search: '',
      leadsBulkUploadDialog: false,
      loading: false,
      assignDateMenu: false,
      selectedLeadId: null,
      selectedLead: null, 
      selectedLeadEdit: null, 
      snackAlert: {
        snackbar: false, 
        snackColor: "", 
        snackVisible: false,
        snackMessage: "", 
        snackBarRight: false, 
        snackBarTop: true,  
      },
      selectedCategory: null,
      selectAll: false,
      mainFilterLoading: false,
      subFilterLoading: false,
      mDistrictLoading: false,
      mDSDLoading: false,
      mGNDLoading: false,
      provinces: [],
      districts: [],
      dsdList: [],
      gndList: [],
      isDisabledProvinceList: false,
      isDisabledDistrictList: false,
      isDisabledDSDLIST: false,
      isDisabledGNDList: false,
      selectedDistrict: [],
      selectedProvince: "",
      selectedDSD: [],
      selectedGND: [],
      agents: [],
      agentProvinceWise: [],
      categories: [],
      subCategories: [],
      allCategories: [],
      permissions: {},
      areaCodesList: [],
      allAreaCodesList: [],

      showMapDialog: false,
      editingLeadIndex: 0,
      mapCenter: { lat: 7.8731, lng: 80.7718 },
      mapZoom: 8,
      mapMarker: null,
      mapInfoWindow: null,
      mapInstance: null,
      placesService: null,
      geocoder: null,
      searchBox: null,
      mapLocation: { lat: null, lng: null, address: '', name: '' }
    };
  },

  computed: {
    filteredItems() {
      if (!this.items || this.items.length === 0) return [];
      
      const selectedDateRange = this.getSelectedDateRange();
      
      let filtered = this.items.filter((item) => {
        let matchesDate = true;
        if (selectedDateRange) {
          const itemDate = this.formatDateForComparison(item.assign_date);
          matchesDate = !!itemDate && itemDate >= selectedDateRange.start && itemDate <= selectedDateRange.end;
        }
        
        if (this.filters.visitedStatus && this.filters.visitedStatus.length) {
          const itemStatus = this.formatVisitedStatus(item.visited_status, item.assign_date).toUpperCase().replace(/\s+/g, ' ');
          const matches = this.filters.visitedStatus.some(filterStatus => {
            const normalizedFilter = filterStatus.toUpperCase().replace(/\s+/g, ' ').trim();
            return itemStatus === normalizedFilter;
          });
          if (!matches) return false;
        }

        if (this.filters.approvalStatus && this.filters.approvalStatus.length) {
          const itemAppStatus = this.formatApprovalStatus(item.approval_status).toUpperCase().trim();
          const matches = this.filters.approvalStatus.some(filterStatus => {
            return itemAppStatus === filterStatus.toUpperCase().trim();
          });
          if (!matches) return false;
        }
        
        if (this.filters.area_code && this.filters.area_code.length) {
          if (!this.filters.area_code.includes(item.area_code)) return false;
        }
        
        return matchesDate;
      });

      if (this.mainSearch) {
        const searchLower = this.mainSearch.toLowerCase();
        filtered = filtered.filter(item => {
          return (
            (item.lead_title && item.lead_title.toLowerCase().includes(searchLower)) ||
            (item.institute_name && item.institute_name.toLowerCase().includes(searchLower)) ||
            (item.salesRep_name && item.salesRep_name.toLowerCase().includes(searchLower)) ||
            (item.address && item.address.toLowerCase().includes(searchLower)) ||
            (item.area_code && item.area_code.toLowerCase().includes(searchLower)) ||
            (item.visited_status && item.visited_status.toLowerCase().includes(searchLower)) ||
            (item.approval_status && this.formatApprovalStatus(item.approval_status).toLowerCase().includes(searchLower)) ||
            (item.create_username && item.create_username.toLowerCase().includes(searchLower))
          );
        });
      }
      
      return filtered;
    }
  },

  created() {
    this.fetchDataintoTable();
    this.imageURL = process.env.VUE_APP_IMAGE_PUBLIC_URL;
  },

  mounted() {
    const dashboardId = 3;
    this.permissions = getPermissions(dashboardId);
    this.fetchMainCategories();
    this.getAllProvinces();
    this.fetchAreaCodes();
    this.fetchAllAreaCodes();
  },

  methods: {
    fetchAllAreaCodes() {
      const token = localStorage.getItem('token');
      axios.get(`${this.baseURL}/api/area-allList`, {
        headers: { 'Authorization': `Bearer ${token}` }
      }).then(res => {
        const rawData = res.data?.data || res.data || [];
        if(Array.isArray(rawData)) {
            const uniqueAreas = [];
            const map = new Map();
            
            for (const item of rawData) {
                if(item.area_code && !map.has(item.area_code)){
                    map.set(item.area_code, true);
                    const desc = item.description ? String(item.description).replace(/<\/?[^>]+(>|$)/g, "").trim() : 'Unknown';
                    uniqueAreas.push({
                        ...item,
                        formattedDisplay: `${desc} | ${item.area_code}`
                    });
                }
            }
            this.allAreaCodesList = uniqueAreas;
        }
      }).catch(err => console.error('Error fetching all area codes:', err));
    },

    formatApprovalStatus(status) {
      if (!status) return 'New Visit';
      let formatted = status.replace(/[_,]/g, ' ').toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
      if (formatted.toUpperCase() === 'PENDING') {
        return 'New Visit';
      }
      return formatted;
    },

    isCreatedByMeUser(createUserId) {
      const currentUserId = localStorage.getItem('userId');
      if (!currentUserId || !createUserId) return false;
      return String(createUserId) === String(currentUserId);
    },

    formatDateForComparison(date) {
      if (!date) return null;

      if (typeof date === 'string') {
        const trimmedDate = date.trim();
        const dateOnlyMatch = trimmedDate.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (dateOnlyMatch) return `${dateOnlyMatch[1]}-${dateOnlyMatch[2]}-${dateOnlyMatch[3]}`;

        const isoDateMatch = trimmedDate.match(/^(\d{4})-(\d{2})-(\d{2})T/);
        if (isoDateMatch) return `${isoDateMatch[1]}-${isoDateMatch[2]}-${isoDateMatch[3]}`;
      }

      const parsedDate = date instanceof Date ? date : new Date(date);
      if (Number.isNaN(parsedDate.getTime())) return null;

      const year = parsedDate.getFullYear();
      const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
      const day = String(parsedDate.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    cancelAndRefresh() {
      this.mainSearch = '';
      this.search = '';
      this.assignDate = null;
      this.assignDateObject = null;
      this.filters = {
        startDate: '',
        endDate: '',
        visitedStatus: [],
        area_code: [], 
        date: [],
        approvalStatus: [],
      };
      this.selectedLead = null;
      this.edit_leads_dialog = false;
      this.view_leads_dialog = false;
      this.fetchDataintoTable();
    },

    getSelectedDateRange() {
      if (!this.assignDate) return null;

      const selectedValues = (Array.isArray(this.assignDate) ? this.assignDate : [this.assignDate])
        .filter(Boolean)
        .map((date) => this.formatDateForComparison(date))
        .filter(Boolean);

      console.log('getSelectedDateRange selectedValues before sort:', selectedValues);

      if (selectedValues.length === 0) return null;

      selectedValues.sort();
      console.log('getSelectedDateRange selectedValues after sort:', selectedValues);

      return {
        start: selectedValues[0],
        end: selectedValues[selectedValues.length - 1]
      };
    },

    clearAssignDate() {
      this.assignDate = null;
    },

    applyFilters() {
      this.filteredItems = [...this.filteredItems];
    },

    formatVisitedStatus(status, assignDate) {
      // If status is already Visited or Completed, return it as is
      if (status) {
        const upper = status.toUpperCase().trim();
        if (upper === 'VISITED' || upper === 'COMPLETED') {
          return upper.charAt(0) + upper.slice(1).toLowerCase();
        }
      }

      // For null, undefined, or other statuses, check against assign date
      if (!assignDate) {
        return 'Not Visited';
      }

      const today = new Date();
      today.setHours(0, 0, 0, 0); // Reset time to start of day for accurate comparison

      const assignDateObj = new Date(assignDate);
      assignDateObj.setHours(0, 0, 0, 0); // Reset time to start of day

      // If today's date is before the assign date, status is 'Pending'
      if (today < assignDateObj) {
        return 'Pending';
      }

      // If today's date is on or after the assign date, status is 'Not Visited'
      if (today >= assignDateObj) {
        // Check for specific statuses like NOT_COMPLETE
        if (status) {
          const upper = status.toUpperCase().trim();
          if (upper === 'NOT_COMPLETE' || upper === 'NOT_COMPLETED' || upper === 'NOT COMPLETED') return 'Not Completed';
          if (upper === 'NOT_VISITED' || upper === 'NOT VISITED') return 'Not Visited';
          if (upper === 'PENDING') return 'Not Visited'; // If it's past due date and still pending, show as Not Visited
        }
        return 'Not Visited';
      }

      return 'Not Visited';
    },

    fetchAreaCodes() {
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token');
      axios.get(`${this.baseURL}/api/area/user/${userId}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      }).then(res => {
        this.areaCodesList = res.data.data || res.data; 
      }).catch(err => console.error('Error fetching area codes:', err));
    },

    fetchSalesRepByAreaCode(areaCode) {
      if(!areaCode) return;
      const token = localStorage.getItem('token');
      axios.get(`${this.baseURL}/api/getSalesRepByAreaCode?area_code=${areaCode}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      }).then(res => {
          const reps = res.data.data || res.data;
          this.agents = Array.isArray(reps) ? reps : [reps];
          if (this.agents.length > 0) {
            this.agents = this.agents.map(agent => ({
              id: agent.id,
              name: agent.salesRep_name || agent.name
            }));
          }
      }).catch(err => {
          console.error('Error fetching sales reps:', err);
      });
    },

    openMapPicker(item, index) {
      this.editingLeadIndex = index;
      this.mapLocation.address = item.address || '';
      this.mapLocation.name = item.institute_name || '';
      this.showMapDialog = true;
      this.$nextTick(() => {
        this.initMapLogic();
      });
    },

    async initMapLogic() {
      if (!this.$refs.myMapRef) return;
      const map = await this.$refs.myMapRef.$mapPromise;
      this.mapInstance = map;

      this.geocoder = new window.google.maps.Geocoder();
      this.placesService = new window.google.maps.places.PlacesService(map);
      this.mapInfoWindow = new window.google.maps.InfoWindow();

      const input = this.$refs.mapSearchInput;
      if (!input) return;
      
      if (this.searchBox) {
        window.google.maps.event.clearInstanceListeners(this.searchBox);
      }
      
      this.searchBox = new window.google.maps.places.Autocomplete(input);
      this.searchBox.bindTo("bounds", map);

      this.searchBox.addListener('place_changed', () => {
          const place = this.searchBox.getPlace();
          if (!place || !place.geometry || !place.geometry.location) return;

          const lat = place.geometry.location.lat();
          const lng = place.geometry.location.lng();
          const address = place.formatted_address || place.name;
          const name = place.name;

          map.setCenter(place.geometry.location);
          map.setZoom(15);
          this.updateMarkerAndInfo(lat, lng, address, name);
      });

      window.google.maps.event.addListener(map, 'click', (event) => {
          if (event.placeId) {
            event.stop();
            this.placesService.getDetails({ placeId: event.placeId }, (place, status) => {
                if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                  const lat = place.geometry.location.lat();
                  const lng = place.geometry.location.lng();
                  const address = place.formatted_address || place.name;
                  const name = place.name;
                  this.updateMarkerAndInfo(lat, lng, address, name);
                }
            });
          } else {
            const lat = event.latLng.lat();
            const lng = event.latLng.lng();
            this.geocoder.geocode({ location: event.latLng }, (results, status) => {
                if (status === 'OK' && results[0]) {
                  const address = results[0].formatted_address;
                  this.updateMarkerAndInfo(lat, lng, address, '');
                }
            });
          }
      });

      if (navigator.geolocation && (!this.mapLocation.lat || !this.mapLocation.lng)) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const pos = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            this.mapInstance.setCenter(pos);
            this.mapInstance.setZoom(14);
          },
          () => {
            console.warn("Geolocation failed or denied.");
          }
        );
      }
    },

    updateMarkerAndInfo(lat, lng, address, name) {
      this.mapLocation.lat = lat;
      this.mapLocation.lng = lng;
      this.mapLocation.address = address;
      if (name) this.mapLocation.name = name;

      if (this.mapMarker) {
          this.mapMarker.setMap(null);
      }

      this.mapMarker = new window.google.maps.Marker({
          position: { lat, lng },
          map: this.mapInstance,
          draggable: true
      });

      window.google.maps.event.addListener(this.mapMarker, 'dragend', (event) => {
        const newLat = event.latLng.lat();
        const newLng = event.latLng.lng();
        this.geocoder.geocode({ location: { lat: newLat, lng: newLng } }, (results, status) => {
           if (status === 'OK' && results[0]) {
              this.updateMarkerAndInfo(newLat, newLng, results[0].formatted_address, '');
           }
        });
      });

      const contentString = `
        <div style="color: black; padding: 5px;">
          <strong style="font-size: 14px;">${this.mapLocation.name || 'Selected Location'}</strong><br>
          <span style="font-size: 12px;">${address}</span><br>
          <span style="font-size: 11px; color: gray;">Lat: ${lat.toFixed(5)}, Lng: ${lng.toFixed(5)}</span>
        </div>
      `;
      this.mapInfoWindow.setContent(contentString);
      this.mapInfoWindow.open(this.mapInstance, this.mapMarker);
    },

    saveMapLocation() {
      if (this.selectedLead && this.selectedLead.selected_lead && this.selectedLead.selected_lead[this.editingLeadIndex]) {
          this.selectedLead.selected_lead[this.editingLeadIndex].address = this.mapLocation.address;
          if (this.mapLocation.name) {
            this.selectedLead.selected_lead[this.editingLeadIndex].institute_name = this.mapLocation.name;
          }
          this.selectedLead.selected_lead[this.editingLeadIndex].lat = this.mapLocation.lat;
          this.selectedLead.selected_lead[this.editingLeadIndex].lng = this.mapLocation.lng;
          this.selectedLead.selected_lead[this.editingLeadIndex].latitude = this.mapLocation.lat;
          this.selectedLead.selected_lead[this.editingLeadIndex].longitude = this.mapLocation.lng;
      }
      if (this.$refs.mapSearchInput) {
        this.$refs.mapSearchInput.value = '';
      }
      this.showMapDialog = false;
    },

    toggleSelectAllOutletItem() {
      if (this.selectAllOutlet) {
        this.selectedItems = this.notVisitedOutletItem.map(item => item.id);
      } else {
        this.selectedItems = [];
      }
    },

    getSanitizedHTML(html) {
      return DOMPurify.sanitize(html);
    },
    convertToPlainText(html) {
      const sanitizedHTML = this.getSanitizedHTML(html);
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = sanitizedHTML;
      return tempDiv.textContent || tempDiv.innerText || '';
    },

    handleInput(value) {
      if (this.selectedItem.not_visited_leads && this.selectedItem.not_visited_leads.length > 0) {
        this.selectedItem.not_visited_leads[0].not_visited_reason = value;
      }
    },

    handleDateChange(newValue) {
      if (newValue) {
        const parsedDate = new Date(newValue);
        if (!isNaN(parsedDate)) {
          this.selectedLead.assign_date = parsedDate.toISOString().split('T')[0];
        } else {
          console.error('Invalid date selected');
        }
      }
    },

    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },

    applyFormat(format) {

      if (format === 'italic') {
        this.textareaStyles.fontStyle =
          this.textareaStyles.fontStyle === 'italic' ? 'normal' : 'italic';
      } else if (format === 'bold') {
        this.textareaStyles.fontWeight =
          this.textareaStyles.fontWeight === 'bold' ? 'normal' : 'bold';
      } else if (format === 'underline') {
        this.textareaStyles.textDecoration =
          this.textareaStyles.textDecoration === 'underline' ? 'none' : 'underline';
      } else if (format === 'color') {
        this.textareaStyles.color = this.selectedColor;
      }
    },

    setAlignment(align) {
      this.textareaStyles.textAlign = align;
    },

    showSnackbar(message, color) {
      this.snackAlert.snackbar = true;
      this.snackAlert.snackMessage = message;
      this.snackAlert.snackColor = color;
    },

    exportExcel() {
      const tableData = this.filteredItems.map((item, index) => ({
        'NO': index + 1,
        'NEW VISIT TITLE': item.lead_title,
        'INSTITUTE NAME': item.institute_name,
        'SALES REP': item.salesRep_name,
        'ADDRESS': item.address,
        'AREA CODE': item.area_code,
        'VISITED STATUS': this.formatVisitedStatus(item.visited_status, item.assign_date),
        'APPROVAL STATUS': this.formatApprovalStatus(item.approval_status),
        'ASSIGN DATE': item.assign_date,
        'CREATED BY': item.create_username || '-'
      }));

      const worksheet = XLSX.utils.json_to_sheet(tableData);

      const columnWidths = [
        {wpx: 50},
        {wpx: 150},
        {wpx: 150},
        {wpx: 120},
        {wpx: 150},
        {wpx: 80},
        {wpx: 100},
        {wpx: 120},
        {wpx: 100},
        {wpx: 120},
      ];
      worksheet['!cols'] = columnWidths;

      Object.keys(worksheet).forEach(cell => {
        if (cell.startsWith('A1')) {
          worksheet[cell].s = {
            font: {bold: true, color: {rgb: "FFFFFF"}},
            fill: {fgColor: {rgb: "1F4E78"}},
            alignment: {horizontal: "center"},
          };
        }
      });

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'New Visit List');
      XLSX.writeFile(workbook, 'new_visits_list.xlsx');

      const fileName = 'new_visits_list.xlsx';
      const file_type = 'excel';
      this.logDocumentDownload(fileName, file_type);
    },

    exportPDF() {
      const doc = new jsPDF();
      doc.setFontSize(18);
      doc.setFont("helvetica", "bold");
      doc.text('New Visit List', 14, 10);

      doc.setFontSize(11);
      doc.setFont("helvetica", "normal");
      doc.text('A comprehensive list of New Visit data', 14, 28);

      const tableData = this.filteredItems.map((item, index) => [
        index + 1,
        item.lead_title,
        item.institute_name,
        item.salesRep_name,
        item.address,
        item.area_code,
        this.formatVisitedStatus(item.visited_status, item.assign_date),
        this.formatApprovalStatus(item.approval_status),
        item.assign_date,
        item.create_username || '-'
      ]);

      const tableColumns = [
        {header: 'NO', dataKey: 'index'},
        {header: 'NEW VISIT TITLE', dataKey: 'lead_title'},
        {header: 'INSTITUTE NAME', dataKey: 'institute_name'},
        {header: 'SALES REP', dataKey: 'salesRep_name'},
        {header: 'ADDRESS', dataKey: 'address'},
        {header: 'AREA CODE', dataKey: 'area_code'},
        {header: 'STATUS', dataKey: 'visited_status'},
        {header: 'APPROVAL', dataKey: 'approval_status'},
        {header: 'ASSIGN DATE', dataKey: 'assign_date'},
        {header: 'CREATED BY', dataKey: 'create_username'}
      ];

      doc.autoTable({
        head: [tableColumns.map(col => col.header)],
        body: tableData,
        startY: 35,
        startX: 5,
        headStyles: {fillColor: [41, 128, 185], textColor: [255, 255, 255], fontSize: 7},
        bodyStyles: {fontSize: 7},
        columnStyles: {
          0: {cellWidth: 8},
          1: {cellWidth: 25},
          2: {cellWidth: 25},
          3: {cellWidth: 20},
          4: {cellWidth: 30},
          5: {cellWidth: 15},
          6: {cellWidth: 15},
          7: {cellWidth: 15},
          8: {cellWidth: 15},
          9: {cellWidth: 15},
        },
        styles: {cellPadding: 3, overflow: 'linebreak'},
        theme: 'striped',
        didDrawPage: function (data) {
          let pageSize = doc.internal.pageSize;
          let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
          doc.text('Page ' + doc.internal.getNumberOfPages(), data.settings.margin.left, pageHeight - 10);
        },
      });

      doc.save('new_visits_list.pdf');

      const fileName = 'new_visits_list.pdf';
      const file_type = 'pdf';
      this.logDocumentDownload(fileName, file_type);
    },

    async logDocumentDownload(fileName, file_type) {
      console.log(fileName);
      try {
        const token = localStorage.getItem('token');
        const userId = localStorage.getItem('userId');

        if (!userId) {
          throw new Error('User ID not found');
        }

        const response = await axios.post(`${this.baseURL}/api/log-document-download`, {
          user_id: userId,
          file_type: file_type,
          file_name: fileName,
          entity_area: 'New Visit Management',

          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (response.status !== 200) {
          throw new Error('Failed to log download');
        }

        console.log('Download logged successfully');
      } catch (error) {
        console.error('Error logging download:', error);
      }
    },

    toggleSelectAll() {
      this.filteredItems.forEach(item => {
        item.selected = this.selectAll;
      });
    },

    confirmDeleteList() {
      this.deleteLeadListEditDialog = true;
    },

    deleteLeadsListItem() {
      this.showLeadsCard = false;
      this.deleteLeadListEditDialog = false;
    },

    getAllProvinces() {
      this.districts = [];
      this.dsdList = [];
      this.gndList = [];
      this.mDistrictLoading = true;
      const header = {
        'X-Requested-With': 'XMLHttpRequest',
        'content-type': 'multipart/form-data',
      };

      axios.post('https://geobizz.tech/api/gis/sortAdminBoundary ', {type: 'province'}, header)
          .then(response => {
            if (response.data.http_status === 'success') {
              this.provinces = response.data;
              this.mDistrictLoading = false;
            }
          })
          .catch(() => {
            this.mDistrictLoading = false;
          });
    },

    getAllDistrictAccProv(province) {
      this.districts = [];
      this.mDistrictLoading = true;
      const headers = {
        'X-Requested-With': 'XMLHttpRequest',
        'content-type': 'multipart/form-data',
      };

      axios.post('https://geobizz.tech/api/gis/sortAdminBoundary ', {type: 'district', value: province}, headers)
          .then(response => {
            if (response.data.http_status === 'success') {
              this.districts = response.data.data;
              this.mDistrictLoading = false;
              this.loadLeadsList(this.selectedLead.lead_main_category, this.selectedLead.lead_sub_category);
            }
          })
          .catch(error => {
            this.mDistrictLoading = false;
            console.error('Error fetching districts:', error);

          });
    },

    getAllDsd(district) {
      this.dsdList = [];
      this.mDSDLoading = true;
      const header = {
        'X-Requested-With': 'XMLHttpRequest',
        'content-type': 'multipart/form-data',
      };

      axios.post('https://geobizz.tech/api/gis/sortAdminBoundary ', {type: 'dsd', value: district}, header)
          .then(response => {
            if (response.data.http_status === 'success') {
              this.dsdList = response.data.data;
              this.mDSDLoading = false;
              this.loadLeadsList(this.selectedLead.lead_main_category, this.selectedLead.lead_sub_category);
            }
          })
          .catch(() => {
            this.mDSDLoading = false;
          });
    },

    getAllGnd(dsd) {
      this.gndList = [];
      this.mGNDLoading = true;
      const header = {
        'X-Requested-With': 'XMLHttpRequest',
        'content-type': 'multipart/form-data',
      };

      axios.post('https://geobizz.tech/api/gis/sortAdminBoundary ', {type: 'gnd', value: dsd}, header)
          .then(response => {
            if (response.data.http_status === 'success') {
              this.gndList = response.data.data;
              this.mGNDLoading = false;
              this.loadLeadsList(this.selectedLead.lead_main_category, this.selectedLead.lead_sub_category);
            }
          })
          .catch(() => {
            this.mGNDLoading = false;
          });
    },

    async fetchMainCategories() {
      try {
        this.mainFilterLoading = true;
        const response = await axios.post('https://geobizztech.celata.org/geoapi/gis/getCategories ', {
          org_code: 'SFA_Backend',
          category: 'Community data',
          type: 'Spatial',
          country: 'SriLanka',
          user: ''
        });

        if (response.data && response.data.dataset) {
          this.allCategories = response.data.dataset;
          this.mainGroup = _.groupBy(this.allCategories, 'main_filter');
          this.categories = Object.keys(this.mainGroup);
          this.mainFilterLoading = false;

          this.geoJsonLayers = this.allCategories
              .filter(val => val.spatial_type !== 'Point')
              .map(val => ({
                data: null,
                name: val.sub_filter,
                main_type: val.main_filter,
                sub_directory: val.data_model
              }));
        } else {
          throw new Error('Invalid response structure');
        }
      } catch (error) {
        // console.error('Error fetching main categories:', error);
        // this.snackAlert.snackbar = true;
        // this.snackAlert.snackColor = 'red';
        // this.snackAlert.snackMessage = 'Failed to load main categories.';
      } finally {
        this.mainFilterLoading = false;
      }
    },

    fetchSubCategories(dataset) {
      this.isDisabledDistrictList = false;
      this.isDisabledDSDLIST = false;
      this.isDisabledGNDList = false;
      this.lead.province = null;
      this.lead.district = [];
      this.lead.dsd = [];
      this.lead.gnd = [];
      this.selectedLead.lead_sub_category = "";

      let sub_filter = _.map(this.allCategories, function (o) {
        if (o.main_filter === dataset)
          return o.sub_filter
      });

      sub_filter = _.reject(sub_filter, _.isNil);
      this.subCategories = sub_filter.sort();
    },

    fetchDataintoTable() {
      const token = localStorage.getItem("token");
      const userId = localStorage.getItem("userId");

      this.loading = true;
      
      const url = `${this.baseURL}/api/v1-selected-leads?page=1&size=5000000&userId=${userId}`;

      axios.get(url, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }).then((response) => {
        const leads = response.data.data || [];

        this.items = leads.map(lead => {
          return {
            ...lead,
            original_lead: lead 
          };
        });

        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        this.loading = false;
      });
    },

    backPageRoute() {
      this.$router.back();
    },
    homeReload() {
      window.location.href = '/dashboard';
    },

    async viewItem(item) {
      try {
        this.centerLoading = true;
        const token = localStorage.getItem('token');
        const user_id = localStorage.getItem('userId');
        
        const leadId = item.lead_id || item.id;

        if (!leadId) {
           this.showSnackbar('Lead ID is missing', 'error');
           this.centerLoading = false;
           return;
        }

        const response = await axios.get(`${this.baseURL}/api/v1/lead/${leadId}`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        const data = response.data.data;
        
        let mobileNum = 'N/A';
        if (data.sales_rep_mobile && data.sales_rep_mobile.mobile_number) {
            mobileNum = data.sales_rep_mobile.country_code ? `${data.sales_rep_mobile.country_code} ${data.sales_rep_mobile.mobile_number}` : data.sales_rep_mobile.mobile_number;
        }

        const selectedLeadsResponse = await axios.get(`${this.baseURL}/api/v1-selected-leads?size=${this.itemsPerPage}&lead_id=${leadId}&userId=${user_id}`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        const selectedLeadsData = selectedLeadsResponse.data.data || [];
        
        const filteredSelectedLead = selectedLeadsData.filter(lead => lead.id === item.id);
        const currentSelected = filteredSelectedLead.length > 0 ? filteredSelectedLead[0] : item;
        
        this.selectedLead = {
          ...data,
          selected_lead_id: item.id,
          agent_name: data.salesRep_name || 'N/A',
          mobile_number: mobileNum, 
          selected_lead: filteredSelectedLead.length > 0 ? filteredSelectedLead : [item],
          visited_status: currentSelected.visited_status,
          approval_status: currentSelected.approval_status,
          approval_reason: currentSelected.approval_reason
        };

        this.notVisitedOutletItem = this.selectedLead.selected_lead.filter(lead => {
          const formattedStatus = this.formatVisitedStatus(lead.visited_status, this.selectedLead.assign_date);
          return formattedStatus === 'Pending' || formattedStatus === 'Not Visited';
        });
        
        this.UserResponseData = { email: '' };

        this.view_leads_dialog = true; 

        const assignSalesRep = data.assign_saleRep;
        if(assignSalesRep) {
          try {
            const userResponse = await axios.get(`${this.baseURL}/api/user/${assignSalesRep}`, {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
              },
            });
            
            if(userResponse.data && userResponse.data.data) {
                this.UserResponseData = userResponse.data.data; 
                if (this.selectedLead.mobile_number === 'N/A') {
                    this.selectedLead.mobile_number = this.UserResponseData.mobile_number || this.UserResponseData.mobile || 'N/A';
                }
            }
          } catch(e) {
            console.warn("Backend 500 error: Could not fetch user info for mobile/avatar.", e.message);
          }
        }
        
        this.centerLoading = false;
      } catch (error) {
        this.centerLoading = false;
        console.error('Error fetching lead data:', error);
        this.showSnackbar('Failed to load lead details', 'error');
      }
    },
    
    async editItem(item) {
      try {
        this.centerLoading = true;
        const token = localStorage.getItem('token');
        const user_id = localStorage.getItem('userId');
        
        const leadId = item.lead_id || item.id;

        if (!leadId) {
           this.showSnackbar('Lead ID is missing', 'error');
           this.centerLoading = false;
           return;
        }

        const response = await axios.get(`${this.baseURL}/api/v1/lead/${leadId}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        const data = response.data.data;

        let mobileNum = 'N/A';
        if (data.sales_rep_mobile && data.sales_rep_mobile.mobile_number) {
            mobileNum = data.sales_rep_mobile.country_code ? `${data.sales_rep_mobile.country_code} ${data.sales_rep_mobile.mobile_number}` : data.sales_rep_mobile.mobile_number;
        }

        const selectedLeadsResponse = await axios.get(`${this.baseURL}/api/v1-selected-leads?size=${this.itemsPerPage}&lead_id=${leadId}&userId=${user_id}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });

        const selectedLeadsData = selectedLeadsResponse.data.data || [];
        
        const filteredSelectedLead = selectedLeadsData.filter(lead => lead.id === item.id);
        const currentSelected = filteredSelectedLead.length > 0 ? filteredSelectedLead[0] : item;

        this.selectedLead = {
            ...data,
            selected_lead_id: item.id,
            agent_name: data.salesRep_name || data.agent_name || 'N/A',
            mobile_number: mobileNum,
            selected_lead: filteredSelectedLead.length > 0 ? filteredSelectedLead : [item],
            visited_status: currentSelected.visited_status,
            approval_status: currentSelected.approval_status,
            approval_reason: currentSelected.approval_reason
        };

        if (this.selectedLead.area_code) {
           this.fetchSalesRepByAreaCode(this.selectedLead.area_code);
        }

        this.assignDateObject = this.selectedLead.assign_date ? new Date(this.selectedLead.assign_date) : new Date();

        this.UserResponseData = { email: '' };

        const registrationNum = this.selectedLead.reg_num || this.selectedLead.assign_saleRep;
        if(registrationNum) {
          try {
              const userResponse = await axios.get(`${this.baseURL}/api/user/${registrationNum}`, {
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${token}`,
                },
              });
              if(userResponse.data && userResponse.data.data) {
                 this.UserResponseData = userResponse.data.data; 
                 if (this.selectedLead.mobile_number === 'N/A') {
                    this.selectedLead.mobile_number = this.UserResponseData.mobile_number || this.UserResponseData.mobile || 'N/A';
                 }
              }
          } catch(e) {
            console.warn("Backend 500 error: Could not fetch user info in edit item.", e.message);
          }
        }

        this.edit_leads_dialog = true;
        this.centerLoading = false;
      } catch (error) {
        this.centerLoading = false;
        console.error('Error parsing lead data:', error);
        this.showSnackbar('Failed to load edit details', 'error');
      }
    },

    sendSms(item) {
      this.selectedItem = {...item};
      this.smsDialog = true;
    },
    sendSMSSubmit() {
      if (!this.selectedItem.mobile_number || !this.selectedItem.email || !this.selectedItem.note) {
        this.snackAlert.snackMessage = 'Please fill out all required fields correctly.';
        this.snackAlert.snackColor = 'red';
        this.snackAlert.snackVisible = true;
        return; 
      }
      const token = localStorage.getItem('token');
      const userId = localStorage.getItem('userId');
      const sendSMSTo = {
        mobileNumber: this.selectedItem.mobile_number,
        email: this.selectedItem.email,
        note: this.selectedItem.note,
        userID: userId
      };

      axios.post(`${this.baseURL}/api/message`, sendSMSTo, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      })
          .then(response => {
            console.log('Success:', response.data);
            this.smsDialog = false;
          })
          .catch(error => {
            console.error('Error:', error);
          });
    },

    validateForm() {
      if (!this.selectedLead.lead_title || this.selectedLead.lead_title.trim() === '') {
        this.showSnackbar('New Visit Title is required.', 'error');
        return false;
      }

      if (!this.selectedLead.area_code) {
        this.showSnackbar('Area Code is required.', 'error');
        return false;
      }

      if (!this.selectedLead.agent_name) {
        this.showSnackbar('Assign Sales Rep is required.', 'error');
        return false;
      }

      if (!this.assignDateObject) {
        this.showSnackbar('Assign Date is required.', 'error');
        return false;
      }
      return true;
    },

    async updateLead() {
      const isValid = this.validateForm();
      if (!isValid) {
        return;
      }

      this.centerLoading = true;
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token');
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      };

      try {
        let formattedDate = this.selectedLead.assign_date;
        if (this.assignDateObject) {
           const d = new Date(this.assignDateObject);
           const offset = d.getTimezoneOffset();
           const dLocal = new Date(d.getTime() - (offset * 60000));
           formattedDate = dLocal.toISOString().split('T')[0];
        }

        const selectedAgentObj = this.agents.find(a => a.name === this.selectedLead.agent_name);
        const assign_saleRep = selectedAgentObj ? selectedAgentObj.id : (this.selectedLead.assign_saleRep || this.selectedLead.reg_num);

        if (this.selectedLead.selected_lead && this.selectedLead.selected_lead.length > 0) {
          const updatePromises = this.selectedLead.selected_lead.map(item => {
            const selectedLeadId = item.id;
            
            const resetPayload = {
              userId: parseInt(userId),
              institute_name: item.institute_name,
              address: item.address,
              latitude: item.lat !== undefined ? item.lat : (item.latitude || null),
              longitude: item.lng !== undefined ? item.lng : (item.longitude || null),
              approval_status: item.approval_status || "PENDING",
              approval_reason: item.approval_reason || "",
              lead_title: this.selectedLead.lead_title,
              area_code: this.selectedLead.area_code,
              assign_saleRep: assign_saleRep,
              salesRep_name: this.selectedLead.agent_name,
              assign_date: formattedDate,
              discription: this.selectedLead.discription || this.selectedLead.lead_description || ''
            };

            return axios.put(`${this.baseURL}/api/v1/selected-leads/${selectedLeadId}/reset-status`, resetPayload, { headers });
          });

          await Promise.all(updatePromises);
        }

        this.showSnackbar("The new visit data was updated successfully!", "success");
        this.centerLoading = false;
        
        this.cancelAndRefresh();

      } catch (error) {
        console.error('Error updating new visit:', error);
        this.showSnackbar("Error updating new visit!", "error");
        this.centerLoading = false;
      }
    },

    openReminderDialog(item) {
      this.selectedItem = {...item};
      this.reminderDialog = true;
    },

    openReminderDialogNew(){
      this.selectedItems = [];
      this.selectAllOutlet = [];
      this.reminderMessage = "";
      this.reminderDialogNew = true;
    },

    async sendReminder() {
      try {
        this.snackAlert.snackColor = 'info';
        this.snackAlert.snackMessage = 'Sending reminder...';
        this.snackAlert.snackbar = true;

        const token = localStorage.getItem('token');
        if (!token) {
          throw new Error('Authorization token is missing');
        }

        const reminderData = {
          title: this.selectedLead.lead_title,
          outletName: this.selectedItem.institute_name,
          outletAddress: this.selectedItem.address,
          assignee: this.selectedLead.agent_name,
          mobileNumber: this.selectedLead.mobile_number,
          email: this.selectedLead.agent_email,
          userID: localStorage.getItem('userId'),
          note: this.selectedItem.note,
        };

        await axios.post(`${this.baseURL}/api/reminder`, reminderData, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        this.snackAlert.snackColor = 'success';
        this.snackAlert.snackMessage = 'Reminder sent successfully.';
        this.reminderDialog = false;

        } catch (error) {
        console.error('Error:', error.response ? error.response.data : error.message);
        if (error.response) {
          switch (error.response.status) {
            case 401:
              this.snackAlert.snackMessage = 'Unauthorized. Please log in again.';
              break;
            case 500:
              this.snackAlert.snackMessage = 'Server error. Please try later.';
              break;
            default:
              this.snackAlert.snackMessage = 'Failed to send reminder. Please try again.';
          }
        } else {
          this.snackAlert.snackMessage = 'Network error. Check your connection.';
        }
      }
    },

    async sendReminderNew() {

      if (!this.reminderMessage || this.reminderMessage.length === 0) {
          this.snackAlert.snackColor = 'error';
          this.snackAlert.snackbar = true;
          this.snackAlert.snackMessage = 'Note is Required.';
        return;
      }

      if (this.reminderMessage.length > 250) {
        this.snackAlert.snackMessage = 'The Note exceeds 250 characters. Please provide a shorter description.';
        this.snackAlert.snackColor = 'error';
        this.snackAlert.snackbar = true;
        return;
      }

      if (!this.selectedItems || this.selectedItems.length === 0) { 
        this.snackAlert.snackMessage = 'At least select one outlet.';
        this.snackAlert.snackColor = 'error';
        this.snackAlert.snackVisible = true;
        return;
      }
      
      try {
        this.snackAlert.snackColor = 'info';
        this.snackAlert.snackMessage = 'Sending reminder...';
        this.snackAlert.snackbar = true;

        const token = localStorage.getItem('token');
        if (!token) {
          throw new Error('Authorization token is missing');
        }

        this.centerLoading = true;
        const selectedOutlets = this.notVisitedOutletItem
          .filter(outlet => this.selectedItems.includes(outlet.id))
          .map(outlet => ({
            outletId: outlet.id,
            outletName: outlet.institute_name,
            outletAddress: outlet.address,
            crmStatus: outlet.crm_status,
            visitedStatus: outlet.visited_status,
          }));

        if (selectedOutlets.length === 0) {
          this.snackAlert.snackMessage = 'Please select at least one institute before sending the reminder.';
          this.snackAlert.snackColor = 'warning';
          this.snackAlert.snackbar = true;
          return;
        }

        const reminderData = {
          title: this.selectedLead.lead_title,
          assignee: this.selectedLead.agent_name,
          mobileNumber: this.selectedLead.mobile_number,
          email: this.selectedLead.agent_email,
          userID: localStorage.getItem('userId'),
          outlets: JSON.stringify(selectedOutlets), 
          note: this.reminderMessage,
        };

        const response = await axios.post(`${this.baseURL}/api/reminderNew`, reminderData, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.status === 200) {
          if (response.data.success) {
            this.snackAlert.snackbar = true;
            this.snackAlert.snackColor = 'success';
            this.snackAlert.snackMessage = 'Reminder sent successfully.';
            this.centerLoading = false;
            this.reminderDialogNew = false;
            this.selectedItems = [];
            this.reminderMessage = "";
          } else {
            throw new Error(response.data.message || 'An unknown error occurred.');
          }
        }
      } catch (error) {
        console.error('Error:', error.response ? error.response.data : error.message);
        
        this.snackAlert.snackbar = true;
        this.snackAlert.snackColor = 'red';

        if (error.response) {
          switch (error.response.status) {
            case 401:
              this.snackAlert.snackMessage = 'Unauthorized. Please log in again.';
              break;
            case 500:
              this.snackAlert.snackMessage = 'Server error. Please try later.';
              break;
            default:
              this.snackAlert.snackMessage = error.response.data?.message || 'Failed to send reminder. Please try again.';
          }
        } else {
          this.snackAlert.snackMessage = error.message || 'Network error. Check your connection.';
        }
      }
    },

    async confirmDelete(item) {
      this.selectedLeadId = item.selected_lead_id || item.id; 
      this.salesLeadList = [];
      this.visited_count = 0;   
      
      this.deleteLeadDialog = true; 

      try {
        const token = localStorage.getItem('token');

        const response = await axios.post(
            `${this.baseURL}/api/checkLeadAssociations/${this.selectedLeadId}`,
            {}, 
            {
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
              }
            }
        );

        if(response.data.message === "No associated data found with visited_status VISITED."){
          this.salesLeadList = []; 
          this.visited_count = 0;   
          this.agent_name = '';     
          this.reg_num = '';        
          this.LeadID = '';         
          this.assign_date = '';    
        } else if (response.data.associated_data?.selected_lead_list) {
          this.salesLeadList = response.data.associated_data.selected_lead_list;
          const leadDetails = response.data.associated_data.lead_details;

          this.visited_count = response.data.associated_data.visited_count;
          this.agent_name = leadDetails.agent_name;
          this.reg_num = leadDetails.reg_num;
          this.LeadID = leadDetails.id;
          this.assign_date = leadDetails.assign_date;
        }
      } catch (error) {
        console.error("Error fetching lead associations:", error);
      }
    },

    resetDialogState() {
      this.salesLeadList = []; 
      this.visited_count = 0;   
      this.agent_name = '';     
      this.reg_num = '';        
      this.LeadID = '';         
      this.assign_date = '';    
    },

    deleteItem() {
      this.centerLoading = true;
      const token = localStorage.getItem('token');
      const targetId = this.selectedLeadId;

      axios.delete(`${this.baseURL}/api/v1/selected-leads/${targetId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      .then(() => {
        this.items = this.items.filter(item => item.id !== targetId);
        
        this.totalItems = this.items.length;
        this.centerLoading = false;
        
        this.deleteLeadDialog = false; 
        this.view_leads_dialog = false;
        this.edit_leads_dialog = false;
        
        this.showSnackbar("The New Visit Was Successfully Deleted", "success");
        
        this.fetchDataintoTable();
      })
      .catch((error) => {
        console.log('Error deleting new visit', error);
        this.centerLoading = false;
        this.deleteLeadDialog = false;
        this.showSnackbar("Failed to delete the new visit", "error");
      });
    },

    createLead() {
      this.$router.push({path: '/add-leads'});
    },

    loadLeadsList(mainCategory, subCategory) {
      console.log('Loading leads for:', mainCategory, subCategory);
    }
  }
};
</script>

<style lang="scss" scoped>
@use "../../styles/lead_management/leads_list.scss" as *;
.custom_font_color_view {
  color: #4CAF50 !important;
  font-weight: 500;
}

.custom_font_color_edit {
  color: #2196F3 !important;
  font-weight: 500;
}

.custom_font_color_delete {
  color: #F44336 !important;
  font-weight: 500;
}

.map-search-input {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1000;
  background-color: #fff;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 300;
  padding: 0 11px 0 13px;
  text-overflow: ellipsis;
  width: 300px;
  height: 40px;
  border-radius: 3px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  outline: none;
}
</style>

<style>
.pac-container {
  background-color: #FFF !important;
  z-index: 1000000 !important;
  position: absolute !important;
}
</style>